var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "speech-bubble" }, [
    _vm.title
      ? _c("p", { staticClass: "speech-bubble__title" }, [
          _vm._v(_vm._s(_vm.title)),
        ])
      : _vm._e(),
    _c(
      "p",
      { staticClass: "speech-bubble__text" },
      [
        _vm._l(_vm.greetingParts, function (part, index) {
          return [
            part.bold
              ? _c("strong", { key: `b-${index}` }, [_vm._v(_vm._s(part.text))])
              : _c("span", { key: `t-${index}` }, [_vm._v(_vm._s(part.text))]),
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }